import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Key } from 'w3c-keys';
import { Avatar } from '../../../../avatar';
import styles from './avatar-cell.module.scss';
export const areEqual = (prevProps, nextProps) => {
    var _a, _b;
    const prev = ((_a = prevProps.colDef) === null || _a === void 0 ? void 0 : _a.colId)
        ? prevProps.data[prevProps.colDef.colId]
        : [];
    const next = ((_b = nextProps.colDef) === null || _b === void 0 ? void 0 : _b.colId)
        ? nextProps.data[nextProps.colDef.colId]
        : [];
    return _.isEqual(prev, next);
};
export const AvatarCell = React.memo(({ context, data, colDef }) => {
    var _a, _b, _c;
    const avatar = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) ? data[colDef.colId] : [];
    const onAvatarClick = () => {
        if (context.onAvatarClick) {
            context.onAvatarClick(avatar);
        }
    };
    const onEnter = (event) => {
        if (event.key === Key.Enter && context.onAvatarClick) {
            context.onAvatarClick(avatar);
        }
    };
    const isAvatarClickable = !!(context === null || context === void 0 ? void 0 : context.onAvatarClick) || !!((_a = avatar[0]) === null || _a === void 0 ? void 0 : _a.isNameLink);
    return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    React.createElement("div", { className: cx(styles.avatarCellContainer, {
            [styles.clickable]: isAvatarClickable,
            [styles.avatarCellContainerDisabled]: (_b = avatar[0]) === null || _b === void 0 ? void 0 : _b.disabled,
        }), "data-testid": "avatar-cell", onClick: onAvatarClick, onKeyDown: onEnter, role: "button", tabIndex: 0 },
        React.createElement(Avatar.Tray, { items: avatar, size: "m", className: styles.avatarTray, isNameLink: (_c = avatar[0]) === null || _c === void 0 ? void 0 : _c.isNameLink, showTooltipOnEllipsis: true })));
}, areEqual);
//# sourceMappingURL=avatar-cell.js.map